import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { ComponentsState } from './types'
import state from './state'
import { TRootState } from '../types'
import { Module } from 'vuex'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} as Module<ComponentsState, TRootState>
